import Button from "@material-ui/core/Button";
import * as React from "react";

export default function PositiveAction({ children, ...props }) {
  return (
    <Button variant="contained" color="primary" {...props}>
      {children}
    </Button>
  );
}
